import "./Picture.scss";
import { PictureProps } from "/Models/Generated/PictureProps";
import cn from "classnames";

export type PictureBehaviour = "FullWidth" | "Cover" | "Default";

export type PictureAspectRatio =
  | "20/13"
  | "16/9"
  | "4/5"
  | "67/50"
  | "3/2"
  | "9/16"
  | "DefaultSquareMobileRectangle";

interface Props extends PictureProps {
  pictureBehaviour?: PictureBehaviour;
  pictureAspectRatio?: PictureAspectRatio;
  noAlt?: boolean;
  eagerLoading?: boolean;
}

const Picture = ({
  altText,
  srcSet,
  imagePropertyName,
  pictureBehaviour,
  pictureAspectRatio,
  noAlt,
  eagerLoading
}: Props) => {
  if (!srcSet || srcSet.length === 0) {
    return (
      imagePropertyName && (
        <div
          className="epi-editContainer picture-norad picture-norad__editor-placeholder"
          data-epi-property-name={imagePropertyName}
          data-epi-property-render={imagePropertyName}
        />
      )
    );
  }

  return (
    srcSet &&
    srcSet.length > 0 && (
      <picture
        data-epi-property-name={imagePropertyName}
        data-epi-property-render={imagePropertyName ? "client" : null}
        className={cn("picture-norad", {
          "picture-norad--cover": pictureBehaviour === "Cover",
          "picture-norad--full-width": pictureBehaviour === "FullWidth",
        })}
      >
        {srcSet.map((val, idx) => (
          <source key={idx} media={val.media} srcSet={val.srcSet} />
        ))}
        <img
          src={srcSet[0].srcSet}
          alt={noAlt ? "" : altText}
          loading={eagerLoading ? "eager" : "lazy"}
          fetchPriority={eagerLoading ? "high" : undefined}
          className={cn("picture-norad-image", {
            "epi-editContainer": !!imagePropertyName,
            "picture-norad-image--full-width": pictureBehaviour === "FullWidth",
            "picture-norad-image--ratio-20-13": pictureAspectRatio === "20/13",
            "picture-norad-image--ratio-16-9": pictureAspectRatio === "16/9",
            "picture-norad-image--ratio-4-5": pictureAspectRatio === "4/5",
            "picture-norad-image--ratio-67-50": pictureAspectRatio === "67/50",
            "picture-norad-image--ratio-3-2": pictureAspectRatio === "3/2",
            "picture-norad-image--ratio-9-16": pictureAspectRatio === "9/16",
            "picture-norad-image--default-square-mobile-rectangle":
              pictureAspectRatio === "DefaultSquareMobileRectangle",
          })}
        />
      </picture>
    )
  );
};
export default Picture;
